import RequestService from '../requestService';
import {client} from '../../client';
import {Dokument, MalJournalpost} from '../../../models';

export default class MalJournalpostService extends RequestService<MalJournalpost,'malJournalpost'> {
    constructor() {
        super('malJournalpost');
    }

    createJournalpost = async () =>client.get<Dokument>( `${this.serviceName}/wspluss/journalpost/ny` );
}
